module.exports = __webpack_public_path__ + "img/117.9.6e8291df.png";